import {FetchError, ResponseError} from '@br/idm-api';

export interface ApiError {
    [key: string]: string[] | ApiError | ApiError[];
}

export function* flattenErrors(errors: ApiError): Generator<string> {
    for (const error of Object.values(errors)) {
        if (Array.isArray(error)) {
            for (const suberror of error) {
                if (typeof suberror === 'string') {
                    yield suberror;
                } else {
                    yield* flattenErrors(suberror);
                }
            }
        } else {
            yield* flattenErrors(error);
        }
    }
}

export async function flattenErrorResponse(error: FetchError | ResponseError): Promise<string[]> {
    if (error instanceof FetchError) {
        return [error.message];
    }
    if (error.response.status === 400) {
        return [...flattenErrors((await error.response.json()) as ApiError)];
    } else {
        return [error.response.statusText];
    }
}
